import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';

@Component({
  selector: 'app-number-input-standalone',
  imports: [CommonModule, FormsModule, ReactiveFormsModule, NgxMaskModule],
  templateUrl: './number-input-standalone.component.html',
  styleUrl: './number-input-standalone.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: NumberInputStandaloneComponent
    }
  ]
})
export class NumberInputStandaloneComponent {
  @Input() numberOfDecimals: string;
  @Input() tabIndex: any;
  @Input()
  set inputValue(value) {
    this.param = value?.toString().split('.').join(',');
  }
  @Input() readonly: boolean = false;
  @Input() allowMinusSign: boolean;
  @Output('keyup') keyUpEvent = new EventEmitter<any>();
  @ViewChild('myInput', { read: ElementRef }) myInput: ElementRef<HTMLInputElement>;
  param;

  onChange: (param: number) => void = () => { };
  onTouched: () => void = () => { };

  constructor() { }

  ngOnInit(): void {
  }

  writeValue(value: number): void {
    this.param = value?.toString().split('.').join(',');
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  doInput() {
    const value = parseFloat(this.param.toString().split(',').join('.'));
    this.onChange(value);
  }

  doBlur() {
    this.onTouched();
  }

  doKeyUp(e) {
    this.keyUpEvent.emit(e);
  }
}
